import React from 'react'
import MenuLink from './menu-link'
import { useUserStore } from '@/store/auth/store'
import { IMenuItem, IMenuLink } from '@/core/constants/menu-define';
export default function MenuItem({ item }: { item: IMenuItem }) {
  const logout = useUserStore(state => state.logout);
  return (
    <div className={`sidebar-section ${item.class ?? ''}`}>
      {item && item.label && <div className="sidebar-title">{item.label}</div>}
      {item &&
        item.links &&
        item.links.length &&
        item.links.map((link: IMenuLink, index: number) => {
          switch (link.link) {
            case '/auth/login':
              return (
                <div
                  key={index}
                  className={`menu-link-item`}
                  onClick={logout}
              >
                {link.icon}
                  <span className={`menu-link-name`}>{link.name}</span>
                </div>
              )
            default:
              return <MenuLink key={index} item={link} />
          }
        })}
    </div>
  )
}
